import { j as o, c as m } from "./utils-BdNIfrGQ.js";
import { T as n } from "./Text-BhLXzYEf.js";
import { S as e } from "./skeleton-CpjuZTJp.js";
import { n as i } from "./normalize-spacing-DY0KSpr_.js";
import { b as p } from "./Button-CzIiGCVn.js";
const l = ({
  variant: t,
  spacing: s = "0",
  size: a,
  ...r
}) => /* @__PURE__ */ o.jsx(
  e,
  {
    className: m(
      p({ variant: t, size: a }),
      i(s),
      "w-[80px] h-[33px] block"
    ),
    ...r,
    children: /* @__PURE__ */ o.jsx(n, {})
  }
);
l.displayName = "ButtonSkeleton";
export {
  l as B
};
